export default function handler (container, link, article) {
  let desc = container.innerText.replace(/\ +/g,'').replace(/[ ]/g,'').replace(/[\r\n]/g,'').substring(0,50)
  var first_img = ''
  if (link && link.thumb) {
    first_img = link.thumb
  } else {
    let img = container.querySelector("img")
    if (img) {
      first_img = img.src
    }
  }
  article.share_info = {
    desc,
    firstImg: first_img
  }
}